(function () {
  document.documentElement.classList.remove('no-js');

  // Luz del borde de vidrio que sigue al mouse
  document.addEventListener('pointermove', function (e) {
    var el = e.target.closest && e.target.closest('.glass');
    if (!el || el.classList.contains('is-tilt')) return;
    var r = el.getBoundingClientRect();
    el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    el.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  // Aparecer al hacer scroll
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Menú móvil
  var toggle = document.querySelector('[data-menu-toggle]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (toggle && mnav) {
    toggle.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Cantidad (+ / -)
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10);
        input.value = Math.max(1, v);
      });
    });
  });

  // Galería de producto
  var main = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.dataset.src;
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  // Variantes: actualiza el id y el precio
  var sel = document.querySelector('[data-variant-select]');
  if (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var idInput = document.querySelector('[data-variant-id]');
      var price = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add-btn]');
      if (idInput) idInput.value = opt.value;
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.querySelector('span').textContent = available ? btn.dataset.label : btn.dataset.soldout;
      }
    });
  }
})();

// Selector de tema, compatible con recargas del encabezado en el editor.
(function () {
  var html = document.documentElement;
  var timer;
  function updateLabels() {
    document.querySelectorAll('.theme-toggle').forEach(function (button) {
      button.setAttribute('aria-label', html.dataset.theme === 'light' ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro');
    });
  }
  updateLabels();
  document.addEventListener('shopify:section:load', updateLabels);
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.theme-toggle')) return;
    clearTimeout(timer);
    html.classList.add('theme-anim');
    void html.offsetWidth;
    var theme = html.dataset.theme === 'light' ? 'dark' : 'light';
    html.setAttribute('data-theme', theme);
    try { localStorage.setItem('ilu-theme', theme); } catch (e) {}
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'light' ? '#F4F3FA' : '#06060b');
    updateLabels();
    timer = setTimeout(function () { html.classList.remove('theme-anim'); }, 600);
  });
})();